import React from 'react';
import { Flex } from '@fluentui/react-northstar';
import PropTypes from "prop-types";
import { observer } from "mobx-react-lite";
import CopyButton from "../../atoms/CopyButton";
import LabelTextComponent from "../LabelTextComponent";

const CallIDTextWithButton = observer((props) => {
    const { label, text, testId } = props;

    return (
        <Flex data-testid={testId} className="call-details-reference-id" vAlign="end">
            <LabelTextComponent
                label={label}
                text={text}
                testId={testId} />
            <CopyButton content={text} />
        </Flex>
    );
});

CallIDTextWithButton.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string,
};

CallIDTextWithButton.defaultProps = {
    label: "",
    text: "",
};

export default CallIDTextWithButton;